import * as React from 'react';

import './SelectOption.scss';

const SelectOption = (props: ISelectOption) => {
  return (
    <div
      className="rp-select--option"
      onClick={() => {
        props.onSelected({ value: props.value, label: props.label });
      }}
    >
      <span className="label">{props.label}</span>
    </div>
  );
};

export default SelectOption;

interface ISelectOption {
  onSelected(value: any): any;
  label: string;
  value: any;
}
